import React from "react";
import classNames from "classnames";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import {GalleryAspectRatio} from "../types/GalleryAspectRatio";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    aspectRatio?: GalleryAspectRatio;
    loading?: HTMLImageElement["loading"];
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
    wrapperClassName?: string;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    const {onClick, aspectRatio, loading = "lazy", srcSm, srcMd, srcLg, tags, onLoad, imgAlt, wrapperClassName} = props;

    const pictureStyle = aspectRatio
        ? {
              aspectRatio,
              display: "block",
              width: "100%",
              overflow: "hidden"
          }
        : undefined;

    const imageStyle = aspectRatio
        ? {
              width: "100%",
              height: "100%",
              objectFit: "cover" as const
          }
        : undefined;

    return (
        <div className={classNames(styles.wrapper, wrapperClassName)}>
            {tags && (
                <div className={styles.tags}>
                    {tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}

            <picture className={styles.galleryImageHolder} style={pictureStyle}>
                {srcLg && <source media="(min-width: 1920px)" srcSet={srcLg} />}

                {srcMd && (
                    <>
                        <source media="(min-width: 1400px)" srcSet={srcMd} />
                        <source media="(min-width: 480px)" srcSet={srcMd} />
                    </>
                )}

                {srcSm && (
                    <>
                        <source media="(min-width: 1024px)" srcSet={srcSm} />
                        <source media="(min-width: 768px)" srcSet={srcSm} />
                    </>
                )}

                <img src={srcSm} alt={imgAlt} loading={loading} style={imageStyle} onClick={onClick} onLoad={onLoad} />
            </picture>
        </div>
    );
};
import React from "react";
import classNames from "classnames";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import {GalleryAspectRatio} from "../types/GalleryAspectRatio";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    aspectRatio?: GalleryAspectRatio;
    loading?: HTMLImageElement["loading"];
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
    wrapperClassName?: string;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    const {onClick, aspectRatio, loading = "lazy", srcSm, srcMd, srcLg, tags, onLoad, imgAlt, wrapperClassName} = props;

    const pictureStyle = aspectRatio
        ? {
              aspectRatio,
              display: "block",
              width: "100%",
              overflow: "hidden"
          }
        : undefined;

    const imageStyle = aspectRatio
        ? {
              width: "100%",
              height: "100%",
              objectFit: "cover" as const
          }
        : undefined;

    return (
        <div className={classNames(styles.wrapper, wrapperClassName)}>
            {tags && (
                <div className={styles.tags}>
                    {tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}

            <picture className={styles.galleryImageHolder} style={pictureStyle}>
                {srcLg && <source media="(min-width: 1920px)" srcSet={srcLg} />}

                {srcMd && (
                    <>
                        <source media="(min-width: 1400px)" srcSet={srcMd} />
                        <source media="(min-width: 480px)" srcSet={srcMd} />
                    </>
                )}

                {srcSm && (
                    <>
                        <source media="(min-width: 1024px)" srcSet={srcSm} />
                        <source media="(min-width: 768px)" srcSet={srcSm} />
                    </>
                )}

                <img src={srcSm} alt={imgAlt} loading={loading} style={imageStyle} onClick={onClick} onLoad={onLoad} />
            </picture>
        </div>
    );
};
